<!-- Must have <template> or else: "[Vue warn]: Component is missing template or render function." -->
<template>
  <div><!-- "The template requires child element" | vue/valid-template-root --></div>
</template>

<script setup lang="ts">
import { setCacheControlHeader } from '~/composables/util'

false && /*#__PURE__*/ defineI18nRoute({
  paths: {
    nl: '/www/[departmentTypeSlug]/[siteSlug]/detail-redirect',
  },
})

const route = useRoute()
const config = useRuntimeConfig()

const url = `${config.public.izbSiteUrl}/afdelingen/${route.params.departmentTypeSlug}/${route.params.siteSlug}`
const params = Object.entries(route.query)
  .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
  .join('&')

setCacheControlHeader()

await navigateTo(url + (params ? `?${params}` : ''), { replace: true, external: true })
</script>
